import { render } from "./TipDetailsRow.vue?vue&type=template&id=05b588c2&scoped=true"
import script from "./TipDetailsRow.vue?vue&type=script&lang=js"
export * from "./TipDetailsRow.vue?vue&type=script&lang=js"

import "./TipDetailsRow.vue?vue&type=style&index=0&id=05b588c2&lang=scss&scoped=true"

import exportComponent from "/Users/cp/Code/betslip/BetslipPortal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b588c2"]])

export default __exports__